export default "__VITE_ASSET__B916mFy0__"